/**
 * Calcule le pourcentage de correspondance et les ingrédients manquants
 */

const normalize = (str) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export function computeMatchForRecipes(
  uniqueRecipes,
  availableIngredients,
  minMatchPercentage,
) {
  return uniqueRecipes
    .map((recipe) => {
      const recipeIngredients = (recipe.ingredients || "")
        .split("\n")
        .map((ing) => normalize(ing.trim()))
        .filter((ing) => ing);

      let matchCount = 0;
      const foundIngredients = [];
      const missingIngredients = [];

      availableIngredients.forEach((userIngredient) => {
        const normalizedUserIng = normalize(userIngredient);
        const found = recipeIngredients.some((recipeIng) =>
          recipeIng.includes(normalizedUserIng),
        );
        if (found) {
          matchCount++;
          foundIngredients.push(userIngredient);
        }
      });

      recipeIngredients.forEach((recipeIng) => {
        const hasIngredient = availableIngredients.some((userIng) => {
          const normalizedUserIng = normalize(userIng);
          return recipeIng.includes(normalizedUserIng);
        });
        if (!hasIngredient) missingIngredients.push(recipeIng);
      });

      const matchPercentage =
        recipeIngredients.length > 0
          ? Math.round((matchCount / recipeIngredients.length) * 100)
          : 0;

      return {
        ...recipe,
        matchPercentage,
        matchCount,
        totalIngredients: recipeIngredients.length,
        foundIngredients,
        missingIngredients: missingIngredients.slice(0, 5),
      };
    })
    .filter((r) => r.matchPercentage >= minMatchPercentage)
    .sort((a, b) => b.matchPercentage - a.matchPercentage);
}
